import { Progress } from '@abb/common-ux';
import * as React from 'react';
import './Waiting.scss';

export const Waiting: React.StatelessComponent<IWaitingProps> = (props: IWaitingProps) => {
  const message = props.message !== undefined ? props.message : 'Just a moment';
  const modal = (
     <div className='waiting'>
      <div className='modal-overlay'>
        <div className='modal-outer'>
          <div className='modal-inner'>
            <Progress /><span>{message}</span>
          </div>
        </div>
      </div>
    </div>
  );
  return (
    props.isOpen ? modal : null
  );
};

export interface IWaitingProps {
    /**
     * This defines whether the modal is open or closed
     */
    isOpen: boolean;
    /**
     * A custom message to be displayed instead of 'Just a moment'
     */
    message?: string;
}
